import {
  BotItemWrapper,
  BotListsWrapper,
} from "./StyledContainer/StyledContainer";
import styled from "styled-components";
import BotContent from "./BotContent/BotContent";

const CategoryTitle = styled.span`
  margin-left: 50px;
  font-size: 16px;
  font-weight: bold;
  @media screen and (max-width: 900px) {
    margin-left: 15px;
  }
`;
const BotLists = ({ bots, tagName }) => {
  return (
    <div>
      {bots.length > 0 ? (
        <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <CategoryTitle>{tagName}</CategoryTitle>
        </div>
      ) : null}
      <BotListsWrapper>
        {bots.map((item, index) => (
          <BotItemWrapper
            key={index}
            href={`../../ai/${item.slug}`}
            isLast={index === bots.length - 1}
            itemCount={bots.length}
          >
            <BotContent item={item} />
          </BotItemWrapper>
        ))}
      </BotListsWrapper>
    </div>
  );
};
export default BotLists;
